import React, { useState, useEffect } from "react";
import { List } from "antd";
import BrandColors from "@brand-colors";
import { useTranslation } from "react-i18next";
import { useAuthProvider } from "pages/Auth/hooks/useAuthProvider";
import whitelabelConfig from "@whitelabel-config";

const PendingSurveyListThankYou = (props: {
  surveyList: Array<any>;
  onSelectSurvey: (surveyMeta: any) => void;
}) => {
  const [selectedSurvey, setSelectedSurvey] = useState();
  const { initAuth } = useAuthProvider();
  const { t } = useTranslation();
  const ActivityStatusEnum: any = {
    0: "None",
    120000000: t("AUTH2FA.OPEN"),
    120000001: t("AUTH2FA.COMPLETED"),
    120000002: "Skipped",
  };
  const brandPrimary = BrandColors.ACTIVITY_BG;
  const buttonBG = BrandColors.ACTIVITY_BUTTON_BG;
  const textColor = BrandColors.ACTIVITY_COLOR;
  const activityBorder = BrandColors.ACTIVITY_BORDER;
  const styles = {
    list_item: {
      padding: "4px 0",
      border: "none",
      borderBottom: "none",
    },
  };
  const hashText = (text: string) => {
    if (text?.length < 5) return text;

    let shown = text?.slice(0, 5);
    let masked = "*".repeat(text?.length - 5);
    return shown + masked;
  };
  const sortedSurveyList = [...props.surveyList].sort((a, b) => {
    return a.MemberName.localeCompare(b.MemberName);
  });

  const SurveyItem = (props: { data: any }) => {
    const actStat = props.data.ActivityStatus;
    const isOpen = actStat === 120000000;
    const isSelected =
      selectedSurvey && selectedSurvey["Urn"] === props.data.Urn;
    const activityName = props.data.ActivityName;
    const cardStyle: React.CSSProperties = {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "7px 10px",
      minHeight: 45,
      borderRadius: 12,
      border: `2px solid ${isOpen ? activityBorder : "#d9d9d9"}`,
      background: isOpen ? (isSelected ? "#ebe7ff" : "#ffffff") : "#f5f5f5",
      cursor: isOpen ? "pointer" : "not-allowed",
      opacity: isOpen ? 1 : 0.75,
      transition: "background 0.2s ease",
    };
    const handleSelect = () => {
      if (!isOpen) return;
      setSelectedSurvey(props.data);
      sessionStorage.setItem(
        "selectedSurveyData",
        JSON.stringify(props.data)
      );
      initAuth("PII");
    };
    return (
      <List.Item
        key={props.data.Urn}
        style={styles.list_item}
        data-testid="pending-survey-btn"
      >
        <div
          role="button"
          tabIndex={isOpen ? 0 : -1}
          aria-disabled={!isOpen}
          onClick={handleSelect}
          onKeyDown={(e) => {
            if (isOpen && (e.key === "Enter" || e.key === " ")) {
              e.preventDefault();
              handleSelect();
            }
          }}
          style={cardStyle}
        >
          <div
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              minWidth: 0,
              flex: 1,
            }}
          >
            <div
              style={{
                color: isOpen ? brandPrimary : "#8c8c8c",
                fontSize: 14,
                fontWeight: 700,
                lineHeight: 1.2,
                marginBottom: activityName ? 6 : 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {hashText(props.data.MemberName)}
            </div>
            {whitelabelConfig.uiSettings.isActivityNameEnabled && activityName && (
              <span
                style={{
                  background: isOpen ? buttonBG : "#e8e8e8",
                  color: isOpen ? textColor : "#8c8c8c",
                  padding: "3px 12px",
                  borderRadius: 16,
                  fontSize: 9,
                  fontWeight: 600,
                  alignSelf: "flex-start",
                  marginTop: 3,
                }}
              >
                {activityName}
              </span>
            )}
          </div>
          <span
            style={{
              background: isOpen ? "#dff5e4" : "#ececec",
              color: isOpen ? "#198754" : "#8c8c8c",
              padding: "2px 15px",
              borderRadius: 16,
              fontSize: 12,
              fontWeight: 600,
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            {isOpen ? ActivityStatusEnum[actStat] : "Closed"}
          </span>
        </div>
      </List.Item>
    );
  };
  useEffect(() => {
    console.log(selectedSurvey);
    if (selectedSurvey) props.onSelectSurvey(selectedSurvey);
  }, [selectedSurvey]);

  if (!sortedSurveyList?.length) {
    return null;
  }
  return (
    <>
      <List
        size="small"
        split={false}
        itemLayout="horizontal"
        dataSource={sortedSurveyList}
        renderItem={(item) => <SurveyItem data={item} />}
      />
    </>
  );
};

export default PendingSurveyListThankYou;
